import { combineReducers } from "redux";
import { CHANGE_STATE_STATUS_REQUEST, CHANGE_STATE_WEIGHT_REQUEST, FETCH_STATES_REQUEST } from "./constants";
import { arrayToObject } from "../../utils/arrayToObject";
import { Action, StatesItems } from "./types";
import { getFailureActionType, getSuccessActionType } from "../utils";

function items(state: StatesItems = {}, action: Action): StatesItems {
  switch (action.type) {
    case getSuccessActionType(FETCH_STATES_REQUEST):
      return arrayToObject(action.payload);

    case CHANGE_STATE_STATUS_REQUEST:
    case CHANGE_STATE_WEIGHT_REQUEST:
      return { ...state, [action.data.stateId]: { ...state[action.data.stateId], isFetching: true } };

    case getSuccessActionType(CHANGE_STATE_STATUS_REQUEST):
    case getSuccessActionType(CHANGE_STATE_WEIGHT_REQUEST):
      return { ...state, [action.data.stateId]: { isFetching: false, ...action.payload } };

    case getFailureActionType(CHANGE_STATE_STATUS_REQUEST):
    case getFailureActionType(CHANGE_STATE_WEIGHT_REQUEST):
      return { ...state, [action.data.stateId]: { ...state[action.data.stateId], isFetching: false } };

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_STATES_REQUEST:
      return true;

    case getSuccessActionType(FETCH_STATES_REQUEST):
    case getFailureActionType(FETCH_STATES_REQUEST):
      return false;
    default:
      return state;
  }
}

export const states = combineReducers({ items, isFetching });
